'use strict';

const jQuery= require('jquery');

export default ReportArcheologyPlaceSelect;

const REPORT_ARCHEOLOGY_PLACE_SELECT_COMPONENT_ATTR = 'data-report-archeology-place-select';
const REPORT_ARCHEOLOGY_PLACE_SELECT_COMPONENT_SELECTOR = '[' + REPORT_ARCHEOLOGY_PLACE_SELECT_COMPONENT_ATTR + ']';
const REPORT_ARCHEOLOGY_PLACE_SELECT_PLACE = '[data-report-archeology-place-select-place]';
const REPORT_ARCHEOLOGY_PLACE_SELECT_GENERATE = '[data-report-archeology-place-select-generate]';

class ReportArcheologyPlaceSelect {

    constructor(element) {
        const component = this;

        component.element = jQuery(element);
        component.selectCategory = component.element.find(REPORT_ARCHEOLOGY_PLACE_SELECT_PLACE);
        component.buttonGenerate = component.element.find(REPORT_ARCHEOLOGY_PLACE_SELECT_GENERATE);

        component.buttonGenerate.prop('disabled', true);

        component.selectCategory.on('change', () => {
            component.buttonGenerate.prop('disabled', false);
        });
    }
}

jQuery(REPORT_ARCHEOLOGY_PLACE_SELECT_COMPONENT_SELECTOR).each((index, element) => new ReportArcheologyPlaceSelect(element));
